import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { PhysicalExamCategory } from '../../models/physical-exam-category';

@Injectable({
  providedIn: 'root',
})
export class PhysicalExamCategoryService {
  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api/general`;


  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/physical-exam-categories?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }



  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<PhysicalExamCategory>>(
      this.apiUrl +  `/physical-exam-categories/index/all`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };


    return this.http.get(
      this.apiUrl +
        `/exports/physical-exam-categories/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }


  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PhysicalExamCategory>(
      this.apiUrl +  `/physical-exam-categories/${uuid}`,
      options
    );
  }

  private authOptions() {
    return {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };
  }

  /** Global metric-card stats for the list page. */
  stats() {
    return this.http.get<{
      total_categories: number;
      total_completed: number;
      average_pe_minutes: number;
      completed_this_month: number;
    }>(this.apiUrl + `/physical-exam-categories/index/stats`, this.authOptions());
  }

  /** All categories, each with completed_physical_exams_count + average_pe_minutes (list rows). */
  withStats() {
    return this.http.get<Array<PhysicalExamCategory>>(
      this.apiUrl + `/physical-exam-categories/index/with-stats`,
      this.authOptions()
    );
  }

  /** Per-category stats for the details header. */
  categoryStats(uuid: string) {
    return this.http.get<{
      total_completed: number;
      completed_this_month: number;
      average_pe_minutes: number;
      price: number;
    }>(this.apiUrl + `/physical-exam-categories/${uuid}/stats`, this.authOptions());
  }

  /** The category's most-recent completed examinations for the details table. */
  recentPhysicalExams(uuid: string) {
    return this.http.get<Array<{
      uuid: string;
      pe_number: string;
      container_number: string | null;
      status: string;
      date: number;
      duration_minutes: number;
    }>>(this.apiUrl + `/physical-exam-categories/${uuid}/recent-physical-exams`, this.authOptions());
  }

  store(category: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<PhysicalExamCategory>(
      this.apiUrl +  `/physical-exam-categories`,
      category,
      options
    );
  }

  update(category: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<PhysicalExamCategory>(
      this.apiUrl +  `/physical-exam-categories/update/${uuid}`,
      category,
      options
    );
  }
}
